import { render, staticRenderFns } from "./PendenciesDataTable.vue?vue&type=template&id=7cca7446"
import script from "./PendenciesDataTable.vue?vue&type=script&lang=js"
export * from "./PendenciesDataTable.vue?vue&type=script&lang=js"
import style0 from "./PendenciesDataTable.vue?vue&type=style&index=0&id=7cca7446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports